export default __webpack_public_path__ + "static/fsp@2x-c7da6a71e5b3dc86ea5e4e0fd2886af1.png";